import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import c from 'classnames'

import Icon from 'discada/dist/Icon'

import { getSocketHealth } from 'selectors/appStatusSelectors'
import { STATUS_HEALTHY, STATUS_UNHEALTHY } from 'utils/socket'

import './SocketHealth.scss'

export function SocketHealth({ socketHealth }) {
  let [show, setShow] = useState(false),
    content = {
      [STATUS_UNHEALTHY]: (
        <>
          <Icon icon="spinner-third" spin /> Reconnecting&hellip;
        </>
      ),
      [STATUS_HEALTHY]: (
        <>
          <Icon icon="check" /> Reconnected!
        </>
      ),
    }

  useEffect(() => {
    socketHealth === STATUS_UNHEALTHY
      ? setShow(true)
      : window.setTimeout(() => setShow(false), 2000)
  }, [socketHealth])

  return (
    <div
      className={c('socket-health', {
        'socket-health-show': show,
        'socket-health-healthy': socketHealth !== STATUS_UNHEALTHY,
        'socket-health-unhealthy': socketHealth === STATUS_UNHEALTHY,
      })}
    >
      <div className="socket-health-inner">{content[socketHealth]}</div>
    </div>
  )
}

function mapStateToProps(state, op) {
  return { ...op, socketHealth: getSocketHealth(state) }
}

export default connect(mapStateToProps)(SocketHealth)
